import { useState, useCallback } from 'react';
import { coloresEstudiosAPI, pagoPorEstudioAPI } from '../../../core/api/api';

export const useColoresEstudios = () => {
  const [colores, setColores] = useState([]);
  const [tiposEstudios, setTiposEstudios] = useState([]);
  const [centros, setCentros] = useState([]);
  const [loading, setLoading] = useState(false);

  const cargarFiltros = useCallback(async () => {
    const [tRes, cRes] = await Promise.all([
      pagoPorEstudioAPI.getTiposEstudios(),
      pagoPorEstudioAPI.getCentros(),
    ]);
    setTiposEstudios(tRes.data || []);
    setCentros(cRes.data || []);
  }, []);

  const buscar = useCallback(async () => {
    setLoading(true);
    try {
      const res = await coloresEstudiosAPI.getColores();
      setColores(res.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  const guardar = useCallback(async (data) => {
    setLoading(true);
    try { await coloresEstudiosAPI.guardar(data); }
    finally { setLoading(false); }
  }, []);

  const actualizar = useCallback(async (id, data) => {
    setLoading(true);
    try { await coloresEstudiosAPI.actualizar(id, data); }
    finally { setLoading(false); }
  }, []);

  const eliminar = useCallback(async (id) => {
    setLoading(true);
    try { await coloresEstudiosAPI.eliminar(id); }
    finally { setLoading(false); }
  }, []);

  return { colores, tiposEstudios, centros, loading, cargarFiltros, buscar, guardar, actualizar, eliminar };
};
